"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Update = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Create_1 = require("../create/Create");
function Update(props) {
    return jsx_runtime_1.jsx(Create_1.Create, Object.assign({}, props), void 0);
}
exports.Update = Update;
//# sourceMappingURL=Update.js.map